export const ExportDoneEvent = 'export-done-event'
export const MaxExportCount = 200000
export const ExportTimestampKey = 'export-timestamp-key'
export const ExportExportingEvent = 'exporting-file-event'
